import { forwardRef } from 'react';
import type { ButtonHTMLAttributes } from 'react';

import { Share as ShareIcon } from '../../../icons';
import { cx } from '../../../utils/cx';

export type ShareButtonProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'children'
>;

/**
 * Share icon button that matches the Good Neighbor marketing site design.
 */
export const ShareButton = forwardRef<HTMLButtonElement, ShareButtonProps>(
  ({ className, disabled, 'aria-label': ariaLabelProp, ...rest }, ref) => (
    <button
      ref={ref}
      type="button"
      aria-label={ariaLabelProp ?? 'Share'}
      disabled={disabled}
      className={cx(
        'inline-flex h-10 w-10 items-center justify-center rounded-md border border-[#d7d3d0] bg-white text-[#a9a29d] transition-colors duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#a9a29d33] hover:border-[#c7c1bb] hover:text-[#8a8079] cursor-pointer disabled:cursor-not-allowed disabled:opacity-60',
        className
      )}
      {...rest}
    >
      <ShareIcon
        aria-hidden="true"
        focusable="false"
        className="h-[17px] w-[17px]"
      />
    </button>
  )
);

ShareButton.displayName = 'ShareButton';
